<template>
  <Container class="container--main">
    <h1 class="title">Inicio de sesión</h1>
    <div class="card">
      <b>Recuerda que: </b>Los datos y/ o información del presente servicio se basan en la Resolución Ministerial Nº 355-2018-VIVIENDA
      y en la Ley Nº 27806, Ley de Transparencia y Acceso a la Información Pública.
    </div>
    <form action class="form" @submit.prevent="login">
      <label class="form-label" for="#email">Correo electrónico:</label>
      <input
        v-model="email"
        class="form-input"
        type="email"
        id="email"
        required
        placeholder="Ingrese su correo electrónico"
      >
      <label class="form-label" for="#password">Contraseña:</label>
      <input
        v-model="password"
        class="form-input"
        type="password"
        id="password"
        placeholder="Ingrese su contraseña"
      >
      <p v-if="error" class="error">Has introducido mal el email o la contraseña.</p>
      <Button
        class="btn__submit"
        tag="button"
        type="submit"
        theme="primary"
        >
          Iniciar sesión
      </Button>
    </form>
    <p class="msg">¿No tienes una cuenta?, 
      <router-link to="/registro">regístrate</router-link>
    </p>
    <hr>
    <p class="msg">
      <router-link to="/recuperar-cuenta">¿Haz olvidado tu contraseña?</router-link>
    </p>
   
  </Container>
</template>

<script>
import auth from "@/logic/auth";
import Button from "@/components/ui/atoms/Button.vue";
import Container from "@/components/ui/objects/Container";

export default {
  components:{
    Button,
    Container
  },
  data: () => ({
    email: "",
    password: "",
    error: false
  }),
  methods: {
    async login() {
      try {
        let response = await auth.login(this.email, this.password);
        let token = response.data.token
        localStorage.setItem('token', token)
        this.$router.push("/edificaciones-instrumentadas");
      } catch (error) {
        this.error = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.login {
  padding: 2rem;
  width: 50%;
  margin: auto;
}
.title {
  text-align: center;
  color: variables.$primary-color;
}
.form {
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  min-width: 350px;
  max-width: 100%;
  border-radius: 5px;
}
.form-label {
  margin-top: 2rem;
  color: variables.$primary-color;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid variables.$primary-color;
  color: rgb(95, 95, 95);
  &:focus {
    outline: 0;
    border: 2px solid variables.$primary-color;
  }
}
.error {
  margin: 1rem 0 0;
  color: red;
}

.msg {
  margin-top: 2rem;
  text-align: center;
}

.btn__submit{
  margin-top: 2rem;
}

.card{
  padding: 1rem;
  background: #e1fcdc;
  border-radius: 10px;
}
.card b{
  color: #385e31;
}
</style>